import styled, { css } from 'styled-components';
import { twoLayeredBoxShadow } from '../../../../commonStyles/styling';
import colors from '../../../../helpers/colors';
import fonts from '../../../../helpers/fonts';
import spacing from '../../../../helpers/spacing';
import { NavText } from '../styles';

export type NavItemProps = {
  active?: boolean;
};

export const NavItemDesktopLink = styled.a<NavItemProps>`
  display: block;
  text-decoration: none;
  text-align: left;
  outline: none;

  border-left: solid 2px ${colors.neutral05};
  padding: ${spacing(1)} ${spacing(2)};

  &:first-of-type {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }

  ${({ active }) =>
    active
      ? css`
          border-color: ${colors.navigationHighlight};
          ${fonts.paragraphLarge}
        `
      : css`
          &:hover {
            color: ${colors.core02};
            text-decoration: underline;
          }
        `}

  &:focus-visible,
  &:active {
    & > ${NavText} {
      outline: none;
      text-decoration: none;
      color: ${colors.core02};
      box-shadow: ${twoLayeredBoxShadow(colors.neutral08, colors.core02)};
      border-radius: 4px;
    }
  }

  ${({ active }) => (active ? fonts.paragraphLarge : fonts.paragraph)}

  & {
    color: ${({ active }) => (active ? colors.neutral01 : colors.neutral02)};
  }
`;
